import { useContext, useEffect } from 'react'
import { Crisp } from 'crisp-sdk-web'
import AuthContext from '../context/AuthContext'

const useCrisp = (subscriptionName?: string) => {
	const authContext = useContext(AuthContext)

	useEffect(() => {
		if (authContext.loggedIn && authContext.user) {
			Crisp.user.setNickname(authContext.user.firstName ?? authContext.user.email)
			Crisp.session.setData({
				userId: authContext.user.uid,
				companyId: authContext.company?.id,
				planId: subscriptionName,
			})
			Crisp.chat.show()
		} else {
			Crisp.chat.hide()
		}
	}, [authContext.loggedIn, authContext.user, authContext.company, subscriptionName])
}

export default useCrisp
